import axios from 'axios';
import router from '@/router';
import { env } from '@/plugins/environmentMixins';

const options = {
    baseURL: env.apiUrl,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        "X-Client-App": env.basePath,
        'User-Agent': navigator.userAgent,
    },
    // timeout: 10000 // Set a timeout of 10 seconds
};


const client = axios.create(options);

export default {
    async execute(method, resource, data) {
        // inject the accessToken for each request
        // let accessToken = await Vue.prototype.$auth.getAccessToken()
        return client({
            method,
            url: resource,
            data,
            //      headers: {
            //        Authorization: `Bearer ${accessToken}`
            //      }
        }).then(req => {
            return req["data"]["data"];
        }).catch((error) => {
            if (error.message === "Network Error") {
                router.push("/server-down").catch(() => { });
            }

            if (error["response"] && error["response"]["data"]) {
                // Filter out the "COD" column if the environment is "PRODUCTION"
                // if (this.$env.type != 'PRODUCTION') {
                console.log(error["response"]["data"]);
                alert(error);
                // }
            } else {
                // if (this.$env.type != 'PRODUCTION') {
                console.log(error);
                alert(error);
                // }
            }



            return error;
        });
    },
    async executeExtended(method, resource, data) {
        // inject the accessToken for each request
        // let accessToken = await Vue.prototype.$auth.getAccessToken()
        return client({
            method,
            url: resource,
            data,
            //      headers: {
            //        Authorization: `Bearer ${accessToken}`
            //      }
        }).then(req => {
            return req["data"];
        });
    },
    get(path, queryString) {
        return this.execute('get', path + (queryString ? "?" + queryString : ""));
    },
    getAllItems(itemName, queryString) {
        return this.execute('get', "/" + itemName + (queryString ? "?" + queryString : ""));
    },
    getItem(itemName, id, queryString) {
        return this.execute('get', "/" + itemName + `/${id}` + (queryString ? "?" + queryString : ""));
    },
    createItem(itemName, data) {
        return this.execute('post', "/" + itemName, data);
    },
    updateItem(itemName, id, data) {
        return this.execute('put', "/" + itemName + `/${id}`, data);
    },
    patchItem(itemName, id, data) {
        return this.execute('patch', "/" + itemName + `/${id}`, data);
    },
    deleteItem(itemName, id) {
        return this.execute('delete', "/" + itemName + `/${id}`);
    },
    // SPEECH
    getSpeechContentsPreview(speechCode, queryString) {
        return this.execute('get', "/speech" + `/${speechCode}` + "/contents_preview" + (queryString ? "?" + queryString : ""));
    },
    //DIALOG
    getDialogContentsPreview(speechCode, queryString) {
        return this.execute('get', "/dialog" + `/${speechCode}` + "/contents_preview" + (queryString ? "?" + queryString : ""));
    },
    // CONVERSATION
    getInterventionsByConversation(conversationId, queryString) {
        return this.execute('get', "/conversation" + `/${conversationId}` + "/interventions" + (queryString ? "?" + queryString : ""));
    },
    // CONVERSATION
    getInterventionsByConversationView(conversationId, queryString) {
        return this.execute('get', "/conversation" + `/${conversationId}` + "/interventions_view" + (queryString ? "?" + queryString : ""));
    },
    getInterventionContext(id, contextRatio, queryString) {
        return this.execute('get', "/intervention" + `/${id}` + "/context" + `/${contextRatio}` + (queryString ? "?" + queryString : ""));
    },
    //
    getTokenCount(id) {
        return this.execute('get', "/conversation" + `/${id}` + "/token_count");
    },
    getInterventionCount(id) {
        return this.execute('get', "/conversation" + `/${id}` + "/intervention_count");
    },
    searchInterventions(queryString) {
        return this.executeExtended('get', "/intervention/search" + (queryString ? "?" + queryString : ""));
    },
    searchMovements(queryString) {
        return this.executeExtended('get', "/movement/search" + (queryString ? "?" + queryString : ""));
    },
    // DOCUMENT
    getMovementContext(id, contextRatio, queryString) {
        return this.execute('get', "/movement" + `/${id}` + "/context" + `/${contextRatio}` + (queryString ? "?" + queryString : ""));
    },
    // WEB
    getVisitorsCount() {
        return this.execute('get', "/app_service/visitors_count");
    },
    incrementVisitorsCount() {
        return this.execute('post', "/app_service/visitors_count");
    }
}
